// src/pages/ResetPassword.js
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API_URL from "../config";
import "./ResetPassword.css";

import axios from "axios";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    if (password !== confirm) return alert("Les mots de passe ne correspondent pas");

    try {
      setLoading(true);
      const res = await axios.post(`${API_URL}/api/auth/reset-password`, {
        email,
        password,
      });

      if (res.data.success) {
        alert("✅ Mot de passe réinitialisé !");
        navigate("/login");
      } else {
        alert(res.data.message || "Erreur lors de la réinitialisation");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Erreur serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-container">
      <h1>Réinitialiser le mot de passe</h1>
      <form onSubmit={handleReset}>
        <input
          type="password"
          placeholder="Nouveau mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirmez le mot de passe"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Réinitialisation..." : "Changer le mot de passe"}
        </button>
      </form>
    </div>
  );
}
